import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCongNoThanhLy,
  updateDataSearch,
} from "../../actions/CongNoThanhLy";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";

export const ModalSearchNangCaoMobile = (props) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchCongNoThanhLy); //dataSearchTaiSan dinh nghia o rootreducer
  const listCongNoFull = useSelector((state) => state.listCongNoThanhLyFull); //listTaiSanFul dinh nghia o rootreducer

  console.log(listCongNoFull, "ds");

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const loadTaiSan = () => {
    getListCongNoThanhLy(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const onSearch = () => {
    // console.log(dataSearch);
    props.onHide(false);
    dispatch(getListCongNoThanhLy(dataSearch));
    loadTaiSan(dataSearch);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListCongNoThanhLy(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-file-search"></i>
          </span>{" "}
          Tìm kiếm nâng cao
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="row repeater-default">
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Mã tài sản</label>
              <br />
              <input
                type="text"
                className="form-control input-sm"
                value={dataSearch.taisanCode}
                onChange={updateTextValue("taisanCode")}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="email-addr">Mã hợp đồng</label>
              <br />
              <input
                type="text"
                className="form-control input-sm"
                value={dataSearch.hopdongCode}
                onChange={updateTextValue("hopdongCode")}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="bio" className="cursor-pointer">
                từ ngày
              </label>
              <DateTimePicker
                value={tuNgay}
                onChange={onChangeDate("tuNgay")}
                placeholder="Từ ngày"
                name="tuNgay"
              ></DateTimePicker>
            </div>

            <div className="skin skin-flat form-group mb-1 col-sm-12 col-md-3 col-12">
              <label for="tel-input">Đến ngày</label>
              <DateTimePicker
                value={denNgay}
                onChange={onChangeDate("denNgay")}
                placeholder="Đến ngày"
                name="dateFrom"
              ></DateTimePicker>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSearch}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-magnify"></i>
          </span>
          Tìm kiếm
        </a>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
